import BaseApi from '../baseApi';

/** Formas de acesso do usuário logado (contas de provedor vinculadas). */
export default class UserIdentityApi extends BaseApi {
  constructor(obj) {
    super(obj || {});
  }

  list() {
    return this.api.get('/user-identities');
  }

  unlink(id) {
    return this.api.delete(`/user-identities/${encodeURIComponent(id)}`);
  }
}
